import cookieCutter from 'cookie-cutter';
import { useRouter } from "next/router";

import Axios from "axios";
import lnbList from '../../common/constants/pass/lnbList';
import Lnb from "../../component/pc/pass/Lnb";

export const goLogin = () => {
  return 'https://join.sbs.co.kr/login/login.do?returnUrl=' + getReturnUrl();
}

export const getReturnUrl = (url) => {
  if (typeof window !== 'undefined') {
    return url ? url : encodeURIComponent(location.href)
  }
}

export const isSbsApp = () => {
  if (typeof window !== 'undefined') {
    if (navigator.userAgent.indexOf('SBSApp') > -1) {
      return true;
    }
  }
  return false;
}

export const isAndroid = () => {
  if (typeof window !== 'undefined') {
    if (/Android/.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export const isIOS = () => {
  if (typeof window !== 'undefined') {
    if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
      return true;
    } else {
      return navigator.maxTouchPoints &&
        navigator.maxTouchPoints >= 2 && (/MacIntel/.test(navigator.userAgent) ||
          /Mac/.test(navigator.userAgent));
    }
  }
  return false;
};

export const inMobileWeb = () => {
  const mobilePathIndex = '/pass/pass'// = routerInfo.path.split('/').indexOf('m');
  return mobilePathIndex > -1 && mobilePathIndex < 3;
}

export const getLnbList = (platform) => {
  const router = useRouter();
  const { lang = 'ko' } = router.query;

  if (lang !== 'ko') {
    platform = platform + '_en';
  }

  return Lnb(lnbList[platform], router.pathname, lang);
}

export const getBillingUrl = (loginJwt, platform, type, combiId) => {
  console.log(platform, type)
  const router = useRouter();
  const { lang = 'ko' } = router.query;
  /*
   * type
   * 1. SBS play 이용권 - 자동결제 : subs
   * 2. SBS play 이용권 - 기간제 : inapp
   * 3. 포인트 : point
   * 4. SBS머니 : money
   */

  let billingUrl = ''; //빌링 URL
  let returnUrl = getReturnUrl();


  if (loginJwt == 'undefined' || loginJwt == null || loginJwt == undefined) {
    billingUrl = goLogin();
  } else {
    if (platform == 'mobile') {
      let nextUrl = getReturnUrl()

      if (type == 'money') {
        billingUrl = 'https://billing.sbs.co.kr/m/fillup/fillup_form.jsp?PayCode=mobile&next_url=' + nextUrl;
      } else if (type == 'point') {    //포인트
        // if (isSbsApp()) {
        billingUrl = 'https://billing.sbs.co.kr/m/pay/charge_coupon_form.jsp';
        // } else {
        //   let webViewTitle = encodeURIComponent('이용권 구매');
        //   let baseUrl = window.location.origin;
        //   let webviewTargetUrl = encodeURIComponent(`${baseUrl}/ko/m/pass/point`);

        //   billingUrl = "intent://webview?title=" + webViewTitle + "&useragent=true&multiwindow=true&targeturl=" + webviewTargetUrl + "#Intent;scheme=siapp;package=kr.co.sbs.videoplayer;end";
        // }
      } else if (type == 'free_point') {
        billingUrl = 'https://billing.sbs.co.kr/m/pay/point_pack_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&next_url=' + nextUrl
      } else if (type == 'subs') {    //자동결제
        billingUrl = 'https://billing.sbs.co.kr/m/pay/auto_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&next_url=' + nextUrl
      } else {  //기간제
        billingUrl = 'https://billing.sbs.co.kr/m/pay/pack_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&next_url=' + nextUrl
      }
    } else if (platform == 'app') {
      /*
       * billType
       * 결제방식
       * all - SBS & GOOGLE 결제 지원
       * sbs - SBS 결제만 지원
       * google - 구글 결제만 지원
       */
      let billType = 'all';
      let appProductId = ''; //구글 상품 ID
      let appCombiId = ''; //구글 상품 ID
      let billingUrl = ''; //빌링 URL
      let langType = '01';    //파라메터
      let nextUrl = 'https://static.cloud.sbs.co.kr/app/sbs/app_payment_redirect.html';
      let eventCheck = false;

      if (type == 'point') {
        billingUrl = 'https://billing.sbs.co.kr/m/pay/charge_coupon_form.jsp&next_url=' + encodeURIComponent(nextUrl) + '&langType=' + lang
      } else if (type == 'free_point') {
        billingUrl = 'https://billing.sbs.co.kr/m/pay/point_pack_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&next_url=' + encodeURIComponent(nextUrl)
      } else { //SBS play 이용권일때
        billType = 'all';
        if (type == 'subs') { // 자동 결제
          billingUrl = 'http://billing.sbs.co.kr/m/pay/auto_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&next_url=' + encodeURIComponent(nextUrl) + '&langType=' + lang;
        } else { // 기간제 결제
          //appProductId = 'term_' + inappCombiId.toLowerCase();
          //appCombiId = inappCombiId;
          billingUrl = 'http://billing.sbs.co.kr/m/pay/pack_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&next_url=' + encodeURIComponent(nextUrl) + '&langType=' + lang;
        }
      }
      return billingUrl;
    } else {
      const option = 'width=570,height=603,resizable=yes,scrollbars=yes'
      const target = 'Billing'
      if (type == 'money') {
        billingUrl = 'https://billing.sbs.co.kr/w3/fillup/fillup_form.jsp?PayCode=mobile&contflag=1'
      } else if (type == 'point') {    //포인트
        billingUrl = 'https://billing.sbs.co.kr/w3/pay/charge_coupon_form.jsp';
      } else if (type == 'subs') {    //자동결제
        // let bpayno = "";
        // if (combiId == 'CB000008011') {
        //   bpayno = "78";
        // } else if (combiId == 'CB000008012') {
        //   bpayno = "79";
        // } else if (combiId == 'CB000008013') {
        //   bpayno = "80";
        // }

        billingUrl = ' https://billing.sbs.co.kr/w3/pay/charge_auto_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&contflag=1';
      } else {  //기간제
        // let prodid = "";
        // if (combiId == 'CB000008001') {
        //   prodid = "1";
        // } else if (combiId == 'CB000008002') {
        //   prodid = "8";
        // }
        billingUrl = 'https://billing.sbs.co.kr/w3/pay/charge_pack_form.jsp?combi_id=' + encodeURIComponent(combiId) + '&contflag=1';
      }
    }
  }

  //console.log(billingUrl)
  return billingUrl;
}

export const googleInappBilling = (type, billingUrl, combiId, inappCombiId, inappEventCombiId) => {
  /*
           * billType
           * 결제방식
           * all - SBS & GOOGLE 결제 지원
           * sbs - SBS 결제만 지원
           * google - 구글 결제만 지원
           */
  let billType = 'all';
  let appProductId = ''; //구글 상품 ID
  let appCombiId = ''; //구글 상품 ID
  let langType = '01';    //파라메터
  let nextUrl = 'https://static.cloud.sbs.co.kr/app/sbs/app_payment_redirect.html';
  let eventCheck = false;


  try {
    location.href = window.inapp.purchaseVoucher(billType, pageGbn, appProductId, appCombiId, billingUrl);
  } catch (e) {
  }
}

export const couponDateFormat = (date) => {
  return date.substring(0, 4) + '.' + date.substring(4, 6) + '.' + date.substring(6, 8);
}

export const couponNumberCheck = (number) => {
  if (number !== 'undefined' && number !== null && number !== undefined) {
    return number.replace(/[^a-zA-Z0-9ㄱ-힣]/g, '').substring(0, 4);
  }
  return '';
}

export const getCouponList = async (loginJwt, useState) => {
  const param = '?jwtToken=' + loginJwt + '&RowCount=10&UseState=' + useState;
  const apiUrl = 'https://billing.sbs.co.kr/m/pay/Coupon_RegList.jsp' + param;
  const couponList = await Axios.get(apiUrl)
    .then(request => request.data)
    .catch(x => console.error(x));

  //console.log(couponList);
  return couponList;
}

export const registerCoupon = async (loginJwt, couponNumber) => {
  const param = '?jwtToken=' + loginJwt + '&CouponNo=' + couponNumber;
  const apiUrl = 'https://billing.sbs.co.kr/m/pay/Coupon_Register.jsp' + param;
  const couponList = await Axios.get(apiUrl)
    .then(request => request.data)
    .catch(x => console.error(x));

  //console.log(couponList);
  return couponList;
}

export const couponCheck = (couponNumber) => {
  if (!couponNumber) {
    alert('쿠폰 번호를 입력해 주세요.');
    return false;
  } else if (couponNumber.length !== 14) {
    alert('쿠폰 번호를 정확히 입력해 주세요.');
    return false;
  }

  return true;
}

// 빌링 관리자용 쿠폰 미리보기 API 
export const previewCoupon = async (couponGroupId) => {
  const param = '?CouponGroupID=' + couponGroupId;
  const apiUrl = 'https://billing.sbs.co.kr/m/pay/CouponGroup_Info.jsp' + param;
  // const apiUrl = 'https://billing.sbs.co.kr/m/pay/CouponGroup_Info.jsp' + param;
  const previewCoupon = await Axios.get(apiUrl)
    .then(request => request.data)
    .catch(x => console.error(x));

  return previewCoupon;
}
// 쿠폰 - 보유쿠폰 카운트
export const getCouponHoldList = async (loginJwt, pageNo) => {
  const param = '?jwtToken=' + loginJwt + '&PageNo=' + pageNo + '&PageSize=6';
  const apiUrl = process.env.NEXT_PUBLIC_API_PASS_HOLD_LIST + param;
  const couponHoldList = await Axios.get(apiUrl)
    .then(request => request.data)
    .catch(x => console.error(x));

  return couponHoldList;
}

// 쿠폰 - 사용완료쿠폰 카운트
const getCouponExpireList = async (loginJwt, pageNo) => {
  const param = '?jwtToken=' + loginJwt + '&PageNo=' + pageNo + '&PageSize=6';
  const apiUrl = process.env.NEXT_PUBLIC_API_PASS_EXPIRE_LIST + param;
  const couponExpList = await Axios.get(apiUrl)
    .then(request => request.data)
    .catch(x => console.error(x));

  return couponExpList;
}

const utils = {
  getCouponHoldList,
  getCouponExpireList,
};

export default utils;